import { ExperimentUtil } from 'client/utils/experiment/experiment-util';
import {
  buildUsedTmvPricingPath,
  buildUsedTmvPricingGraphqlPath,
  buildUsedTmvPricingWithOptionsPath,
  buildUsedTmvPricingWithOptionsGraphqlPath,
} from 'client/data/models/vehicle-v2';

export const selectEmo4346Context = state => ({
  useGraphqlUsedTmv:
    ExperimentUtil.getForcedOrAssignedRecipeName({
      state,
      campaignName: 'EMO-4346',
      defaultVal: 'ctrl',
    }) === 'chal1',
});

export function getAppraiserUsedTmvPath({
  styleId,
  isExtendedReport = false,
  useGraphqlUsedTmv = false,
  withOptions = false,
}) {
  const useGraphql = isExtendedReport && useGraphqlUsedTmv;
  if (withOptions) {
    return useGraphql
      ? buildUsedTmvPricingWithOptionsGraphqlPath(styleId)
      : buildUsedTmvPricingWithOptionsPath(styleId);
  }
  return useGraphql ? buildUsedTmvPricingGraphqlPath(styleId) : buildUsedTmvPricingPath(styleId);
}
